enum GuestPointType {
  addAutoOrderPoint = "受注時自動付与",
  addManualOrderPoint = "受注時手動付与",
  usePoint = "受注時利用",
  addManualPoint = "手動付与",
}

export default GuestPointType;
